export default __webpack_public_path__ + "1cbedba1b0db847dc74bf4542a3d5e7e.png";